import Timeline from "./Timeline"

export default function Career({ careers, toggleCareer }) {
	const displayCareers = careers.filter((c) => {
        let v = c.timeline && typeof c.timeline.display

        if (v === 'boolean') {
            return c.timeline.display
        }

        return true
    })

    return (
        <div className="career">
            <Timeline 
            	careers={displayCareers}
            	toggleCareer={toggleCareer}
        	/>
        </div>
    )
}